<template>
  <div style="padding-top: 80px; ">
    <TopNav activeIndex="4"></TopNav>
    <el-container class="user-container animated fadeIn" v-show="show">
      <div class="user-left-container">
        <el-menu class="user-el-menu" default-active="1" active-text-color="#ffffff" @select="selectEdi" style="margin-top: 10px;">
          <el-menu-item index="1">
            <img src="../../../static/images/n1.png" />
            <span slot="title">基本信息</span>
          </el-menu-item>
          <el-menu-item index="2">
            <img src="../../../static/images/n4.png" />
            <span slot="title">我的学校</span>
          </el-menu-item>
          <el-menu-item index="3">
            <img src="../../../static/images/n2.png" />
            <span slot="title">安全设置</span>
          </el-menu-item>
          <el-menu-item index="4">
            <img src="../../../static/images/n3.png" />
            <span slot="title">学习记录</span>
          </el-menu-item>
          <el-menu-item index="5">
            <img src="../../../static/images/n4.png" />
            <span slot="title">作品收藏</span>
          </el-menu-item>
          <el-menu-item index="6">
            <img src="../../../static/images/n4.png" />
            <span slot="title">联系客服</span>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="user-right-container">
      </div>
    </el-container>
  </div>
</template>

<script>
import TopNav from '@/components/top/TopNav'
import '../../css/animate.min.css'
export default {
  components: {
    TopNav
  },
  data () {
    return {
      show: false,
      index: 1,
      total: 0,
      list: [{
        img: 'http://www.bcqu.vip/sb3/covers/104424841565094718797',
        title: '玛丽苏的故事',
        lookCount: 10,
        zanCount: 100
      },
      {
        img: 'http://www.bcqu.vip/sb3/covers/1641580871565094463666',
        title: '20世纪的战斗',
        lookCount: 10,
        zanCount: 100
      },
      {
        img: 'http://www.bcqu.vip/sb3/covers/6090235391565094780320',
        title: '植物大战特朗普',
        lookCount: 10,
        zanCount: 100
      },
      {
        img: 'http://www.bcqu.vip/sb3/covers/5200100251565094629869',
        title: '活着的鸡',
        lookCount: 10,
        zanCount: 100
      },
      {
        img: 'http://www.bcqu.vip/sb3/covers/7069300721565094804888',
        title: '星巴克收购机',
        lookCount: 10,
        zanCount: 100
      },
      {
        img: 'http://www.bcqu.vip/sb3/covers/5200100251565094629869',
        title: '滚学涨',
        lookCount: 10,
        zanCount: 100
      }
      ]
    }
  },
  mounted () {
    this.show = true
    this.total = this.list.length
  },
  props: {},
  methods: {

  }
}

</script>
<style>
  @import url('./user.css');

</style>



// WEBPACK FOOTER //
// src/pages/user/user.vue